// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"dbf6f39c11a8838a828b","966":"2dee2ee1f43e9a2e139a"}[chunkId] + ".js";
};